import { render, staticRenderFns } from "./KSRSingleJob.vue?vue&type=template&id=b83d974c&"
import script from "./KSRSingleJob.vue?vue&type=script&lang=js&"
export * from "./KSRSingleJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports